import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChevronRight16 = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M5 1.4375L11.2533 7.69083C11.294 7.73141 11.3262 7.77961 11.3482 7.83266C11.3702 7.8857 11.3815 7.94257 11.3815 8C11.3815 8.05743 11.3702 8.11429 11.3482 8.16734C11.3262 8.22039 11.294 8.26859 11.2533 8.30917L5 14.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
